import { ListCollection } from "@ark-ui/react";
import { useMemo } from "react";

type CollectionItem = ListCollection<{
  label: string;
  value: string;
}>["items"][number];

interface FilterOptionsProps {
  filterOnSearch: boolean;
  query: string;
  minSearchLength: number;
  maxDropdownItems?: number;
  collection: ListCollection;
}

interface FilteredItem extends CollectionItem {
  isHighlighted: boolean;
}

export const useFilterOptions = ({
  filterOnSearch,
  query,
  minSearchLength = 0,
  maxDropdownItems,
  collection,
}: FilterOptionsProps): FilteredItem[] => {
  return useMemo<FilteredItem[]>(() => {
    if (filterOnSearch) {
      if (query.length < minSearchLength) {
        return [];
      }

      const filtered = (collection.items as CollectionItem[])
        .filter(
          (option: CollectionItem) =>
            !query || option.label.toLowerCase().includes(query.toLowerCase()),
        )
        .map((option) => ({ ...option, isHighlighted: false }));

      return maxDropdownItems ? filtered.slice(0, maxDropdownItems) : filtered;
    } else {
      return (collection.items as CollectionItem[]).map(
        (option: CollectionItem) => ({
          ...option,
          isHighlighted:
            !!query && option.label.toLowerCase().includes(query.toLowerCase()),
        }),
      );
    }
  }, [collection, query, minSearchLength, maxDropdownItems, filterOnSearch]);
};
